import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "question-header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "back-wrapper" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "d-flex flex-row-reverse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_svg = _resolveComponent("back-svg")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_the_modal = _resolveComponent("the-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "category-header-name",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)), ["enter"]))
          }, [
            _createVNode(_component_back_svg, { class: "mr-6" }),
            _cache[2] || (_cache[2] = _createTextVNode(" Back ", -1))
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.isQuestionEditMode)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 0,
                size: "small",
                onClick: _ctx.setAnswerMode
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Stop edit mode", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_the_modal, {
      "is-visible": _ctx.preventAnswerModeModal.isOpen.value,
      onOnCancel: _ctx.preventAnswerModeModal.close,
      onOnConfirm: _ctx.preventAnswerModeModal.close
    }, {
      content: _withCtx(() => [...(_cache[4] || (_cache[4] = [
        _createElementVNode("p", { class: "text-center" }, "You have one unsaved question. Please save or cancel before switching to answer mode.", -1)
      ]))]),
      footer: _withCtx(() => [
        _createVNode(_component_base_button, {
          onClick: _ctx.preventAnswerModeModal.close
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("Ok", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["is-visible", "onOnCancel", "onOnConfirm"])
  ], 64))
}